var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconRefresh = function SvgIconRefresh(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "refresh_FILL0_wght400_GRAD0_opsz48",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.643,
    height: 15.643,
    viewBox: "0 0 15.643 15.643",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "refresh_FILL0_wght400_GRAD0_opsz48-2",
    "data-name": "refresh_FILL0_wght400_GRAD0_opsz48",
    d: "M15.821,23.643A7.8,7.8,0,0,1,8,15.821,7.8,7.8,0,0,1,15.821,8a7.559,7.559,0,0,1,3.642.843,8.624,8.624,0,0,1,2.713,2.31V8h1.466v6.208H17.434V12.742h4.106a7.486,7.486,0,0,0-2.371-2.371,6.169,6.169,0,0,0-3.348-.9,6.3,6.3,0,0,0-6.355,6.355,6.3,6.3,0,0,0,6.355,6.355,6.411,6.411,0,0,0,3.715-1.161,6.038,6.038,0,0,0,2.346-3.067H23.4a7.49,7.49,0,0,1-2.811,4.131A7.78,7.78,0,0,1,15.821,23.643Z",
    transform: "translate(-8 -8)",
    fill: "#25556e"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconRefresh);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_refresh.a14dedf9fdaa68b2c5caaea3384820e6.svg";